<template>
	<div class="user-list-container">
		<!-- 列表页 -->
		<template v-if="showFlag">
			<!-- 页面头部 -->
			<div class="page-header">
				<div class="header-content">
					<div class="header-icon">
						<svg class="icon" viewBox="0 0 24 24">
							<path d="M16,4C18.11,4 19.97,5.69 20,7.8H22V9.8H20C19.97,11.91 18.11,13.6 16,13.6C13.89,13.6 12.03,11.91 12,9.8H2V7.8H12C12.03,5.69 13.89,4 16,4M16,5.9C14.84,5.9 13.9,6.84 13.9,8C13.9,9.16 14.84,10.1 16,10.1C17.16,10.1 18.1,9.16 18.1,8C18.1,6.84 17.16,5.9 16,5.9M8,14.9C10.11,14.9 11.97,16.59 12,18.7H22V20.7H12C11.97,22.81 10.11,24.5 8,24.5C5.89,24.5 4.03,22.81 4,20.7H2V18.7H4C4.03,16.59 5.89,14.9 8,14.9M8,16.8C6.84,16.8 5.9,17.74 5.9,18.9C5.9,20.06 6.84,21 8,21C9.16,21 10.1,20.06 10.1,18.9C10.1,17.74 9.16,16.8 8,16.8Z"/>
						</svg>
					</div>
					<div class="header-text">
						<h1 class="page-title">用户管理</h1>
						<p class="page-description">系统用户信息的管理与维护</p>
					</div>
					<div class="header-actions">
						<el-button 
							v-if="isAuth('yonghu','新增')" 
							type="primary" 
							icon="el-icon-plus" 
							@click="addOrUpdateHandler()" 
							class="add-btn"
						>
							新增用户
						</el-button>
					</div>
				</div>
			</div>

			<!-- 搜索和筛选区域 -->
			<div class="filter-section">
				<el-card class="filter-card" shadow="never">
					<div class="filter-content">
						<el-form :inline="true" :model="searchForm" class="search-form">
							<div class="filter-row">
								<div class="filter-group">
									<label class="filter-label">用户账号</label>
									<div class="filter-input">
										<el-input 
											v-model="searchForm.yonghuzhanghao" 
											placeholder="请输入用户账号" 
											clearable
											prefix-icon="el-icon-user"
											class="search-input"
										></el-input>
									</div>
								</div>
								
								<div class="filter-group">
									<label class="filter-label">用户姓名</label>
									<div class="filter-input">
										<el-input 
											v-model="searchForm.yonghuxingming" 
											placeholder="请输入用户姓名" 
											clearable
											prefix-icon="el-icon-user-solid"
											class="search-input"
										></el-input>
									</div>
								</div>
								
								<div class="filter-group">
									<label class="filter-label">性别</label>
									<div class="filter-input">
										<el-select 
											v-model="searchForm.xingbie" 
											placeholder="请选择性别" 
											clearable
											class="search-select"
										>
											<el-option 
												v-for="(item,index) in xingbieOptions" 
												:key="index" 
												:label="item" 
												:value="item"
											></el-option>
										</el-select>
									</div>
								</div>
								
								<div class="filter-actions">
									<el-button 
										type="primary" 
										icon="el-icon-search" 
										@click="search()"
										class="search-btn"
									>
										查询
									</el-button>
									<el-button 
										icon="el-icon-refresh" 
										@click="resetSearch()"
										class="reset-btn"
									>
										重置
									</el-button>
								</div>
							</div>
						</el-form>
					</div>
				</el-card>
			</div>

			<!-- 操作栏 -->
			<div class="toolbar-section" v-if="dataListSelections.length > 0">
				<el-card class="toolbar-card" shadow="never">
					<div class="toolbar-content">
						<div class="selection-info">
							<i class="el-icon-info"></i>
							<span>已选择 <strong>{{ dataListSelections.length }}</strong> 项</span>
						</div>
						<div class="batch-actions">
							<el-button 
								v-if="isAuth('yonghu','删除')" 
								type="danger" 
								icon="el-icon-delete" 
								@click="deleteHandler()"
								:disabled="dataListSelections.length <= 0"
								class="batch-delete-btn"
							>
								批量删除
							</el-button>
						</div>
					</div>
				</el-card>
			</div>

			<!-- 数据表格 -->
			<div class="table-section">
				<el-card class="table-card" shadow="never">
					<el-table 
						class="data-table"
						:data="dataList"
						v-loading="dataListLoading"
						@selection-change="selectionChangeHandler"
						empty-text="暂无数据"
						element-loading-text="加载中..."
						element-loading-spinner="el-icon-loading"
					>
						<el-table-column 
							type="selection" 
							width="55" 
							align="center"
						></el-table-column>
						
						<el-table-column 
							label="序号" 
							type="index" 
							width="70" 
							align="center"
							:index="getTableIndex"
						></el-table-column>
						
						<el-table-column 
							prop="yonghuzhanghao"
							label="用户账号"
							min-width="120"
							show-overflow-tooltip
						>
							<template slot-scope="scope">
								<div class="user-account">
									<i class="el-icon-user"></i>
									<span>{{ scope.row.yonghuzhanghao }}</span>
								</div>
							</template>
						</el-table-column>
						
						<el-table-column 
							prop="yonghuxingming"
							label="用户姓名"
							min-width="120"
							show-overflow-tooltip
						>
							<template slot-scope="scope">
								<div class="user-name">
									<span>{{ scope.row.yonghuxingming || '未设置' }}</span>
								</div>
							</template>
						</el-table-column>
						
						<el-table-column 
							prop="touxiang" 
							label="头像" 
							width="100" 
							align="center"
						>
							<template slot-scope="scope">
								<div class="avatar-container">
									<div class="avatar-wrapper" v-if="scope.row.touxiang">
										<img 
											v-if="scope.row.touxiang.substring(0,4)==='http'" 
											:src="scope.row.touxiang.split(',')[0]" 
											class="user-avatar"
											@error="handleImageError"
										>
										<img 
											v-else 
											:src="$base.url + scope.row.touxiang.split(',')[0]" 
											class="user-avatar"
											@error="handleImageError"
										>
									</div>
									<div class="avatar-placeholder" v-else>
										<i class="el-icon-user-solid"></i>
									</div>
								</div>
							</template>
						</el-table-column>
						
						<el-table-column 
							prop="xingbie"
							label="性别"
							width="100"
							align="center"
						>
							<template slot-scope="scope">
								<el-tag 
									:type="getGenderTagType(scope.row.xingbie)"
									size="small"
									class="gender-tag"
								>
									<i :class="getGenderIcon(scope.row.xingbie)"></i>
									{{ scope.row.xingbie || '未设置' }}
								</el-tag>
							</template>
						</el-table-column>
						
						<el-table-column 
							prop="lianxifangshi"
							label="联系方式"
							min-width="140"
							show-overflow-tooltip
						>
							<template slot-scope="scope">
								<div class="contact-info" v-if="scope.row.lianxifangshi">
									<i class="el-icon-phone"></i>
									<span>{{ scope.row.lianxifangshi }}</span>
								</div>
								<span v-else class="no-data">未设置</span>
							</template>
						</el-table-column>
						
						<el-table-column 
							label="操作" 
							width="200" 
							align="center"
							fixed="right"
						>
							<template slot-scope="scope">
								<div class="action-buttons">
									<el-button 
										v-if="isAuth('yonghu','查看')" 
										type="info" 
										size="mini" 
										icon="el-icon-view"
										@click="addOrUpdateHandler(scope.row.id, 'info')"
										class="action-btn view-btn"
									>
										详情
									</el-button>
									<el-button 
										v-if="isAuth('yonghu','修改')" 
										type="primary" 
										size="mini" 
										icon="el-icon-edit"
										@click="addOrUpdateHandler(scope.row.id)"
										class="action-btn edit-btn"
									>
										编辑
									</el-button>
									<el-button 
										v-if="isAuth('yonghu','删除')" 
										type="danger" 
										size="mini" 
										icon="el-icon-delete"
										@click="deleteHandler(scope.row.id)"
										class="action-btn delete-btn"
									>
										删除
									</el-button>
								</div>
							</template>
						</el-table-column>
					</el-table>
				</el-card>
			</div>

			<!-- 分页 -->
			<div class="pagination-section">
				<el-pagination
					@size-change="sizeChangeHandle"
					@current-change="currentChangeHandle"
					:current-page="pageIndex"
					:page-sizes="[10, 20, 50, 100]"
					:page-size="pageSize"
					layout="total, sizes, prev, pager, next, jumper"
					:total="totalPage"
					class="data-pagination"
				></el-pagination>
			</div>
		</template>
		
		<!-- 添加/修改页面 -->
		<add-or-update v-if="addOrUpdateFlag" :parent="this" ref="addOrUpdate"></add-or-update>
	</div>
</template>

<script>
import axios from 'axios'
import AddOrUpdate from "./add-or-update";
export default {
  data() {
    return {
      searchForm: {
        key: ""
      },
      form:{},
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      dataListSelections: [],
      showFlag: true,
      sfshVisiable: false,
      shForm: {},
      chartVisiable: false,
      chartVisiable1: false,
      chartVisiable2: false,
      chartVisiable3: false,
      chartVisiable4: false,
      chartVisiable5: false,
      addOrUpdateFlag:false,
      layouts: ["total","prev","pager","next","sizes","jumper"],

    };
  },
  created() {
    this.init();
    this.getDataList();
    this.contentStyleChange()
  },
  mounted() {
  },
  filters: {
    htmlfilter: function (val) {
      return val.replace(/<[^>]*>/g).replace(/undefined/g,'');
    }
  },
  components: {
    AddOrUpdate,
  },
  methods: {

    contentStyleChange() {
      this.contentPageStyleChange()
    },
    // 分页
    contentPageStyleChange(){
      let arr = []

      // if(this.contents.pageTotal) arr.push('total')
      // if(this.contents.pageSizes) arr.push('sizes')
      // if(this.contents.pagePrevNext){
      //   arr.push('prev')
      //   if(this.contents.pagePager) arr.push('pager')
      //   arr.push('next')
      // }
      // if(this.contents.pageJumper) arr.push('jumper')
      // this.layouts = arr.join()
      // this.contents.pageEachNum = 10
    },








    // 获取表格索引
    getTableIndex(index) {
      return (this.pageIndex - 1) * this.pageSize + index + 1;
    },

    // 重置搜索
    resetSearch() {
      this.searchForm = {
        yonghuzhanghao: '',
        yonghuxingming: '',
        xingbie: ''
      };
      this.search();
    },

    // 处理图片加载错误
    handleImageError(event) {
      event.target.style.display = 'none';
    },

    // 获取性别标签类型
    getGenderTagType(gender) {
      if (gender === '男') return 'primary';
      if (gender === '女') return 'warning';
      return 'info';
    },

    // 获取性别图标
    getGenderIcon(gender) {
      if (gender === '男') return 'el-icon-male';
      if (gender === '女') return 'el-icon-female';
      return 'el-icon-question';
    },

    init () {
          this.xingbieOptions = "男,女".split(',')
    },
    search() {
      this.pageIndex = 1;
      this.getDataList();
    },

    // 获取数据列表
    getDataList() {
      this.dataListLoading = true;
      let params = {
        page: this.pageIndex,
        limit: this.pageSize,
        sort: 'id',
        order: 'desc',
      }
           if(this.searchForm.yonghuzhanghao!='' && this.searchForm.yonghuzhanghao!=undefined){
            params['yonghuzhanghao'] = '%' + this.searchForm.yonghuzhanghao + '%'
          }
           if(this.searchForm.yonghuxingming!='' && this.searchForm.yonghuxingming!=undefined){
            params['yonghuxingming'] = '%' + this.searchForm.yonghuxingming + '%'
          }
           if(this.searchForm.xingbie!='' && this.searchForm.xingbie!=undefined){
            params['xingbie'] = this.searchForm.xingbie
          }
      this.$http({
        url: "yonghu/page",
        method: "get",
        params: params
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.dataList = data.data.list;
          this.totalPage = data.data.total;
        } else {
          this.dataList = [];
          this.totalPage = 0;
        }
        this.dataListLoading = false;
      });
    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1;
      this.getDataList();
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val;
      this.getDataList();
    },
    // 多选
    selectionChangeHandler(val) {
      this.dataListSelections = val;
    },
    // 添加/修改
    addOrUpdateHandler(id,type) {
      this.showFlag = false;
      this.addOrUpdateFlag = true;
      this.crossAddOrUpdateFlag = false;
      if(type!='info'){
        type = 'else';
      }
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id,type);
      });
    },
    // 下载
    download(file){
      window.open(`${file}`)
    },
    // 删除
    deleteHandler(id) {
      var ids = id
        ? [Number(id)]
        : this.dataListSelections.map(item => {
            return Number(item.id);
          });
      this.$confirm(`确定进行[${id ? "删除" : "批量删除"}]操作?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$http({
          url: "yonghu/delete",
          method: "post",
          data: ids
        }).then(({ data }) => {
          if (data && data.code === 0) {
            this.$message({
              message: "操作成功",
              type: "success",
              duration: 1500,
              onClose: () => {
                this.search();
              }
            });
          } else {
            this.$message.error(data.msg);
          }
        });
      });
    },


  }

};
</script>
<style lang="scss" scoped>
.user-list-container {
	background: #f8fafc;
	min-height: 100vh;
	padding: 24px;
}

// 页面头部
.page-header {
	margin-bottom: 24px;
	
	.header-content {
		display: flex;
		align-items: center;
		justify-content: space-between;
		background: white;
		padding: 24px;
		border-radius: 8px;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

		.header-icon {
			width: 56px;
			height: 56px;
			background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
			border-radius: 12px;
			display: flex;
			align-items: center;
			justify-content: center;
			box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);

			.icon {
				width: 24px;
				height: 24px;
				fill: white;
			}
		}

		.header-text {
			flex: 1;
			margin-left: 16px;

			.page-title {
				font-size: 24px;
				font-weight: 600;
				color: #1e293b;
				margin: 0 0 4px 0;
			}

			.page-description {
				color: #64748b;
				font-size: 14px;
				margin: 0;
			}
		}

		.header-actions {
			.add-btn {
				padding: 12px 24px;
				font-weight: 500;
				border-radius: 8px;
			}
		}
	}
}

// 筛选区域
.filter-section {
	margin-bottom: 24px;

	.filter-card {
		border-radius: 8px;
		border: none;

		:deep(.el-card__body) {
			padding: 24px;
		}
	}

	.filter-content {
		.search-form {
			margin: 0;

			.filter-row {
				display: flex;
				align-items: flex-end;
				gap: 20px;
				flex-wrap: wrap;
			}

			.filter-group {
				display: flex;
				flex-direction: column;
				min-width: 200px;

				.filter-label {
					font-size: 14px;
					font-weight: 500;
					color: #374151;
					margin-bottom: 8px;
				}

				.filter-input {
					.search-input,
					.search-select {
						width: 200px;
					}
				}
			}

			.filter-actions {
				display: flex;
				gap: 12px;
				margin-left: auto;

				.el-button {
					padding: 10px 20px;
					font-weight: 500;
					border-radius: 6px;
				}

				.search-btn {
					background: #3b82f6;
					border-color: #3b82f6;
				}

				.reset-btn {
					color: #6b7280;
					border-color: #d1d5db;

					&:hover {
						color: #374151;
						border-color: #9ca3af;
					}
				}
			}
		}
	}
}

// 工具栏
.toolbar-section {
	margin-bottom: 16px;

	.toolbar-card {
		border-radius: 8px;
		border: none;

		:deep(.el-card__body) {
			padding: 16px 24px;
		}
	}

	.toolbar-content {
		display: flex;
		align-items: center;
		justify-content: space-between;

		.selection-info {
			display: flex;
			align-items: center;
			gap: 8px;
			color: #3b82f6;
			font-size: 14px;

			i {
				font-size: 16px;
			}

			strong {
				color: #1d4ed8;
			}
		}

		.batch-actions {
			.batch-delete-btn {
				padding: 8px 16px;
				font-size: 13px;
			}
		}
	}
}

// 表格区域
.table-section {
	margin-bottom: 24px;

	.table-card {
		border-radius: 8px;
		border: none;

		:deep(.el-card__body) {
			padding: 0;
		}
	}

	.data-table {
		:deep(.el-table__header) {
			th {
				background: #f8fafc;
				color: #374151;
				font-weight: 600;
				border-bottom: 1px solid #e5e7eb;
				padding: 16px 0;

				.cell {
					padding: 0 16px;
				}
			}
		}

		:deep(.el-table__body) {
			tr {
				&:hover {
					background: #f8fafc;
				}

				td {
					border-bottom: 1px solid #f1f5f9;
					padding: 16px 0;

					.cell {
						padding: 0 16px;
					}
				}
			}
		}

		// 用户账号
		.user-account {
			display: flex;
			align-items: center;
			gap: 8px;
			color: #374151;

			i {
				color: #3b82f6;
			}
		}

		// 用户姓名
		.user-name {
			color: #374151;
			font-weight: 500;
		}

		// 头像容器
		.avatar-container {
			display: flex;
			justify-content: center;

			.avatar-wrapper {
				width: 48px;
				height: 48px;
				border-radius: 50%;
				overflow: hidden;
				border: 2px solid #e5e7eb;

				.user-avatar {
					width: 100%;
					height: 100%;
					object-fit: cover;
				}
			}

			.avatar-placeholder {
				width: 48px;
				height: 48px;
				border-radius: 50%;
				background: #f3f4f6;
				display: flex;
				align-items: center;
				justify-content: center;
				color: #9ca3af;
				font-size: 20px;
			}
		}

		// 性别标签
		.gender-tag {
			i {
				margin-right: 4px;
			}
		}

		// 联系方式
		.contact-info {
			display: flex;
			align-items: center;
			gap: 6px;
			color: #374151;

			i {
				color: #10b981;
			}
		}

		.no-data {
			color: #9ca3af;
			font-style: italic;
		}

		// 操作按钮
		.action-buttons {
			display: flex;
			gap: 8px;
			justify-content: center;
			flex-wrap: wrap;

			.action-btn {
				padding: 6px 12px;
				font-size: 12px;
				border-radius: 4px;
				min-width: auto;

				&.view-btn {
					background: #6b7280;
					border-color: #6b7280;
					color: white;

					&:hover {
						background: #4b5563;
						border-color: #4b5563;
					}
				}

				&.edit-btn {
					background: #3b82f6;
					border-color: #3b82f6;

					&:hover {
						background: #2563eb;
						border-color: #2563eb;
					}
				}

				&.delete-btn {
					background: #ef4444;
					border-color: #ef4444;

					&:hover {
						background: #dc2626;
						border-color: #dc2626;
					}
				}
			}
		}
	}
}

// 分页区域
.pagination-section {
	display: flex;
	justify-content: center;

	.data-pagination {
		background: white;
		padding: 20px;
		border-radius: 8px;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
	}
}

// 响应式设计
@media (max-width: 1024px) {
	.user-list-container {
		padding: 20px;
	}

	.filter-section {
		.filter-content {
			.search-form {
				.filter-row {
					flex-direction: column;
					align-items: stretch;
					gap: 16px;
				}

				.filter-group {
					min-width: auto;

					.filter-input {
						.search-input,
						.search-select {
							width: 100%;
						}
					}
				}

				.filter-actions {
					margin-left: 0;
					justify-content: center;

					.el-button {
						flex: 1;
						max-width: 120px;
					}
				}
			}
		}
	}

	.table-section {
		.data-table {
			:deep(.el-table__body) {
				tr td {
					padding: 12px 0;

					.cell {
						padding: 0 8px;
					}
				}
			}

			.action-buttons {
				flex-direction: column;
				gap: 4px;

				.action-btn {
					width: 100%;
					max-width: 60px;
					padding: 4px 8px;
					font-size: 11px;
				}
			}
		}
	}
}

@media (max-width: 768px) {
	.user-list-container {
		padding: 16px;
	}

	.page-header {
		.header-content {
			flex-direction: column;
			gap: 16px;
			text-align: center;

			.header-text {
				margin-left: 0;

				.page-title {
					font-size: 20px;
				}
			}
		}
	}

	.toolbar-section {
		.toolbar-content {
			flex-direction: column;
			gap: 12px;
			text-align: center;
		}
	}

	.table-section {
		.data-table {
			.avatar-container {
				.avatar-wrapper,
				.avatar-placeholder {
					width: 36px;
					height: 36px;
				}
			}
		}
	}
}

@media (max-width: 480px) {
	.user-list-container {
		padding: 12px;
	}

	.page-header {
		.header-content {
			padding: 16px;

			.header-icon {
				width: 48px;
				height: 48px;

				.icon {
					width: 20px;
					height: 20px;
				}
			}

			.header-text {
				.page-title {
					font-size: 18px;
				}

				.page-description {
					font-size: 13px;
				}
			}

			.header-actions {
				.add-btn {
					padding: 10px 16px;
					font-size: 13px;
				}
			}
		}
	}

	.filter-section {
		.filter-card {
			:deep(.el-card__body) {
				padding: 16px;
			}
		}
	}

	.table-section {
		// 移动端表格可能需要横向滚动
		overflow-x: auto;

		.table-card {
			:deep(.el-card__body) {
				padding: 0;
			}
		}

		.data-table {
			min-width: 600px;

			.avatar-container {
				.avatar-wrapper,
				.avatar-placeholder {
					width: 32px;
					height: 32px;
				}
			}

			.action-buttons {
				.action-btn {
					padding: 4px 6px;
					font-size: 10px;
					min-width: 44px;
				}
			}
		}
	}

	.pagination-section {
		.data-pagination {
			padding: 16px;
			
			:deep(.el-pagination) {
				.el-pagination__total,
				.el-pagination__jump {
					display: none;
				}
			}
		}
	}
}
</style>
